import { tipAttrs } from "../../tooltip";
/**
 * **The ACC / DIFF stepper** — the signed accuracy count an armed attack carries (`aim.accuracy`:
 * positive is accuracy, negative is difficulty). One part for every surface that arms an attack:
 * {@link AttackAimControls} (a Skirmish or Barrage shot), the Quick and Full Tech choosers' Invade
 * controls ({@link TechAimControls}), and the command menu, which renders those same parts
 * (`token-command-menu` 3.1-3.2). The markup and class names are the sheet choosers' own.
 */
export function AccuracyStepper({ value, onChange }: { value: number; onChange: (next: number) => void }) {
  return (
    <div className="skirmish-hud-acc">
      <span className="skirmish-hud-acc-label">ACC / DIFF</span>
      <div className="skirmish-hud-stepper">
        <button type="button" className="skirmish-hud-step" aria-label="decrease accuracy" {...tipAttrs({ label: "Decrease ACC / DIFF", hint: "one less accuracy, or one more difficulty" })} onClick={() => onChange(value - 1)}>
          −
        </button>
        <span className="skirmish-hud-acc-val">{value > 0 ? `+${value}` : value}</span>
        <button type="button" className="skirmish-hud-step" aria-label="increase accuracy" {...tipAttrs({ label: "Increase ACC / DIFF", hint: "one more accuracy, or one less difficulty" })} onClick={() => onChange(value + 1)}>
          +
        </button>
      </div>
    </div>
  );
}
